import {SlugView} from "@src/pages/workspace/slug-view";
import {
  createFileRoute,
  redirect,
  useMatches,
  useParams,
} from "@tanstack/react-router";
import {TProfile} from "@zeg/instant/types";
export const Route = createFileRoute("/_auth/_work-layout/$workspaceSlug/")({
  beforeLoad: async ({context, params}) => {
    const {workspaceSlug} = params;
    const chosenWorkspace = context.auth.profiles.find(
      (profile) => profile.$workspace?.slug === workspaceSlug
    );
    const shortcuts = chosenWorkspace?.$workspace?.shortcuts;
    if (shortcuts && shortcuts.length >= 1) {
      throw redirect({
        to: `/${workspaceSlug}/shortcuts/${shortcuts[0]?.slug}` as string,
      });
    }
    const agents = chosenWorkspace?.$workspace?.agents;
    if (agents && agents.length >= 1) {
      throw redirect({
        to: `/${workspaceSlug}/agents/${agents[0]?.slug}` as string,
      });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const accumulatedContext = useMatches({
    select: (matches) => matches[matches.length - 1].context,
  });
  const {workspaceSlug} = useParams({
    from: "/_auth/_work-layout/$workspaceSlug",
  });
  const activeWorkspace = accumulatedContext.auth.profiles.find(
    (profile) => profile.$workspace?.slug === workspaceSlug
  );
  return <SlugView activeWorkspace={activeWorkspace as TProfile} />;
}
